import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/forms/$formId')({
  beforeLoad: ({ params }) => {
    if (params.formId === 'new') {
      throw redirect({
        to: '/dashboard/settings/appointment-forms/new',
        search: { surface: 'INTAKE' },
        replace: true,
      });
    }

    throw redirect({
      to: '/dashboard/settings/appointment-forms/$id/edit',
      params: { id: params.formId },
      replace: true,
    });
  },
  component: () => null,
});
